import React from "react";
import "./tour.css";
import { Link } from "react-router-dom";  
import { FaUmbrellaBeach, FaUsers, FaMapMarkerAlt, FaEnvelope, FaPhone, FaHome } from "react-icons/fa";

function Tour4() {
  return (
    <section className="tour4-container">
        <div className="banner">
          <img 
            src="/explore srilanka.png" 
            alt="Airport Pickup and Drop Banner" 
            className="banner-image" 
          />
        </div>
      {/* Title */}
      <h1 className="tour4-title">4-Day Sri Lanka Beach Tour: Sun, Sand, and Serenity</h1>

      <div className="tour4-layout">
        {/* Left Section */}
        <div className="tour4-left">
          {/* Info Boxes */}
          <div className="tour4-info-cards">
            <div className="info-card">
              <FaUmbrellaBeach className="info-icon" />
              <div>
                <h4>Travel</h4>
                <p>3 Night, 4 Day</p>
              </div>
            </div>

            <div className="info-card">
              <FaUsers className="info-icon" />
              <div>
                <h4>Group Size</h4>
                <p>Family / Couple</p>
              </div>
            </div>

            <div className="info-card">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <h4>Destinations</h4>
                <p>Beach</p>
              </div>
            </div>
          </div>

          {/* Tour Highlights */}
          <div className="tour4-highlights">
            <h3>Tour Highlights:</h3>
            <p>Negombo, Bentota, Galle, and Colombo.</p>

            <div className="tour4-gallery">
              <img src="/negombo.png" alt="Negombo" />
             <img src="/bentota.jpg" alt="Bentota" />
               <img src="/Bentota-tour4.jpg" alt="Bentota" />
              <img src="/GALLE.jpg" alt="Galle Fort" />
              <img src="/galle-f.webp" alt="Galle Fort" />
              <img src="/turtles.jpg" alt="Turtle Hatchery" />
              <img src="/water-sports.jpg" alt="Water Sports" />
              <img src="/colombo.jpg" alt="Colombo" />
               <img src="/lotus2.jpg" alt="colombo" />
              <img src="/gangarama.jpg" alt="Colombo" />
         
             
            </div>
          </div>

          {/* Itinerary */}
          <div className="tour4-itinerary">
            <h3>Day 1: Arrival in Negombo</h3>
            <ul>
              <li>Arrive at Bandaranaike International Airport.</li>
              <li>Transfer to Negombo, a coastal town famous for its sandy beaches and fishing villages.</li>
              <li>Activities:</li>
              <ul>
                <li>Relax on the beach.</li>
                <li>Explore the Negombo Fish Market and Dutch Fort.</li>
                <li>Optional: Sunset boat ride through the Dutch Canal.</li>
              </ul>
              <li>Overnight stay in Negombo.</li>
            </ul>

            <h3>Day 2: Bentota – Water Sports and Beaches</h3>
            <ul>
              <li>Morning transfer to Bentota, Sri Lanka’s water sports hub.</li>
              <li>Activities:</li>
              <ul>
                <li>Jet skiing, banana boat rides, or windsurfing (optional).</li>
                <li>Visit the Kosgoda Turtle Hatchery.</li>
                <li>Relax by the beach or enjoy a refreshing dip in the ocean.</li>
              </ul>
              <li>Overnight stay in Bentota.</li>
            </ul>

            <h3>Day 3: Galle Fort and Coastal Charm</h3>
            <ul>
              <li>Drive to the UNESCO World Heritage Site of Galle Fort.</li>
              <li>Activities:</li>
              <ul>
                <li>Walk along the ramparts of Galle Fort.</li>
                <li>Explore boutiques, art galleries, and cafes within the fort.</li>
                <li>Visit the lighthouse and enjoy scenic ocean views.</li>
              </ul>
              <li>Evening return to Colombo.</li>
              <li>Overnight stay in Colombo.</li>
            </ul>

            <h3>Day 4: Colombo City Tour and Departure</h3>
            <ul>
              <li>Morning city tour of Colombo.</li>
              <li>Activities:</li>
              <ul>
                <li>Visit Gangaramaya Temple, Independence Square, and Pettah Floating Market.</li>
                <li>Shop for souvenirs at Laksala or Odel.</li>
                <li>Transfer to the airport for departure.</li>
              </ul>
            </ul>
          </div>
        </div>

        {/* Right Sidebar */}
        <aside className="tour4-sidebar">
          <div className="sidebar-box">
            <h3>BOOK NOW TOURS</h3>
            <p>
              Ready to explore Sri Lanka’s beaches or need help planning your dream vacation? 
              Our team at <strong>Eco Rich Travels</strong> is here to assist you.
            </p>
            <Link to="/bookings" style={{ textDecoration: 'none' }}>
            <button className="btn-primary">BOOK TOUR</button>
            </Link>

                                <button 
            className="btn-secondary"
            onClick={() => window.open(`https://wa.me/94742947134`, '_blank')}
          >
            Easy Quote
          </button>

          </div>

          <div className="sidebar-box contact-box">
            <h3>READY TO START YOUR ADVENTURE?</h3>
            <p>
              Book your tour today or reach out to us for any questions. We’re here to help you plan the perfect trip!
            </p>

            <div className="contact-details">
              <p><FaEnvelope /> info@ecorichtravels.com</p>
              <p><FaPhone /> +94 74 294 7134</p>
              <p><FaHome /> 520, Pamunugama Rd, Negombo</p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default Tour4;
